import { ForgeIterationMessage } from "@supernova-studio/model";
import { DTOForgeParticipant } from "./participant";
import { z } from "zod";
export const DTOForgeIterationMessage = ForgeIterationMessage.omit({
    participant: true,
}).extend({
    participant: DTOForgeParticipant,
});
export const DTOCreateForgeIterationMessage = DTOForgeIterationMessage.omit({
    projectIterationId: true,
    participant: true,
});
export const DTOGetForgeIterationMessageResponse = z.object({
    message: DTOForgeIterationMessage.nullable(),
});
export const DTOForgeIterationMessagesListResponse = z.object({
    messages: z.array(DTOForgeIterationMessage),
});
export const DTOUpdateForgeIterationMessage = DTOCreateForgeIterationMessage.extend({ id: z.string() });
export const DTOCreateForgeIterationMessageResponse = z.object({
    message: DTOForgeIterationMessage,
});
export const DTOUpdateForgeIterationMessageResponse = z.object({
    message: DTOForgeIterationMessage.nullable(),
});
export const DTODeleteForgeIterationMessageResponse = z.object({
    ok: z.literal(true),
});
